import React from 'react';

import { gql } from '@apollo/client';
import { FCWithFragments } from '@modernloop/shared/components';
import { Typography } from '@mui/material';

import { ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment } from 'src/generated/mloop-graphql';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

import logError from 'src/utils/logError';

interface Fragments {
  activityLog: ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment;
}

const ActivityLogTaskCandidateSubmittedAvailability: FCWithFragments<Fragments> = ({ activityLog }) => {
  let note = '';
  let sourcingLinkId = null;

  // eslint-disable-next-line no-underscore-dangle
  if (activityLog?.details?.__typename === 'ActivityLogTaskAvailabilityDetails') {
    note = activityLog.details.note;
    sourcingLinkId = activityLog.details.sourcingLinkId;
  } else {
    logError('ActivityLogTaskCandidateSubmittedAvailability: details is not ActivityLogTaskAvailabilityDetails');
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabel={`submitted availability${sourcingLinkId ? ' via sourcing link' : ''}`}
      actionLabelKey={
        sourcingLinkId ? undefined : 'hiring-dashboard-candidates:candidates.activityLog.submittedAvailability'
      }
    >
      {note && (
        <ActivityLogContent
          sx={{
            borderRadius: '4px 12px 12px 12px',
          }}
          content={
            <Typography sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }} variant="body1">
              {note}
            </Typography>
          }
        />
      )}
    </ActivityLogBase>
  );
};

ActivityLogTaskCandidateSubmittedAvailability.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskCandidateSubmittedAvailability_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogTaskAvailabilityDetails {
          sourcingLinkId
          note
        }
      }

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCandidateSubmittedAvailability;
